<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="12">
        <v-card class="elevation-4">
          <v-card-title>
            Create Business
            <div class="flex-grow-1"></div>
            <v-btn color="primary" @click="$router.push('/agent/businesslist')">Business List</v-btn>
          </v-card-title>

          <v-overlay v-model="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>

          <v-card-text>
            <v-divider></v-divider>
            <v-form v-model="valid" enctype="multipart/form-data" id="createbusiness">
              <v-container>
                <v-row>
                  <v-col cols="12" md="12">
                    <h4 class="title">Business Information</h4>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12" sm="12">
                    <v-label class="font-weight-bold">Welecome Message</v-label>
                  </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="12" sm="12">
                   
                     <editor
                      api-key="kmqk9zj3cswmwgz5j95fcwx8fh4nutj31o7ru7va5lxht7nk"
                      initialValue=""
                      v-model="welcomemsg"
                      :init="editorConfigDescription"
                    ></editor>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="businessName"
                      name="businessName"
                      label="Business Name"
                      required
                      v-validate="'required|max:255'"
                      :error-messages="errors.collect('bussinesName')"
                      data-vv-name="businessName"
                    ></v-text-field>
                  </v-col>

                   <v-col cols="12" md="4">
                   
                    <v-autocomplete 
                      label="Business Type"
                      v-model="businessType"  
                      name="businessType"  
                      item-text="name"
                      item-value="value"  
                      :items="types"  
                      v-validate="'required'"
                      :error-messages="errors.collect('businessType')"
                      data-vv-name="businessType"></v-autocomplete>
                  </v-col>

                   <v-col cols="12" md="4">
                    <v-autocomplete 
                      label="Agent"
                      v-model="creater_id"  
                      name="creater_id"  
                      item-text="name"
                      item-value="user_id"  
                      :items="agents"  
                      >
                    </v-autocomplete>
                  </v-col>

                </v-row>

                <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="ownername"
                      name="ownername"
                      label="Business Owner Name"
                      data-vv-name="ownername"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="3">
                   <v-text-field
                      v-model="ownerposition"
                      name="ownerposition"
                      label="Owner Position"
                      data-vv-name="ownerposition"
                    ></v-text-field>
                    
                  </v-col>
                  <v-col cols="12" md="3">
                   
                    <v-autocomplete 
                      label="Business Activity"
                      v-model="businessactivity_id"  
                      name="businessactivity_id"  
                      item-text="name"
                      item-value="id"  
                      :items="businessactivities"  
                     ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="3">
                   
                    <v-select 
                    label="Currency"
                    v-model="currency"  
                    name="currencyid"  
                    item-text="name"
                    item-value="id"  
                    :items="currencies">
                      <template v-slot:selection="data">
                        <v-icon v-text="data.item.icon" class="mr-3"></v-icon>{{data.item.name}}
                      </template>
                      <template v-slot:item="data">
                        <v-icon v-text="data.item.icon" class="mr-3"></v-icon>{{data.item.name}}
                      </template>
                    </v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="email"
                      name="email"
                      label="Business Email"
                      type="email"
                      
                      required
                      v-validate="'required|email'"
                      :error-messages="errors.collect('email')"
                      data-vv-name="email"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="phone"
                      name="phone"
                      label="Landline"
                      type="tel"
                      required
                      v-validate="'required|max:100'"
                      :error-messages="errors.collect('phone')"
                      data-vv-name="phone"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="mobile"
                      name="mobile"
                      label="Mobile"
                      type="tel"
                      data-vv-name="mobile"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="whatsapp"
                      name="whatsapp"
                      label="Whatsapp"
                      type="tel"
                      data-vv-name="whatsapp"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="website"
                      name="website"
                      label="Website"
                      type="text"
                      data-vv-name="website"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="numberOfEmployees"
                      name="numberOfEmployees"
                      label="No. Of Employees"
                      
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <h4 class="title">Contact Information</h4>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="contactName" name="contactName" label="Contact Name"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="contactPosition" name="contactPosition" label="Contact Position"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="email" name="contactEmail" label="Contact Email"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="contactPhone" type="tel" name="contactPhone" label="Personal Mobile"></v-text-field>
                  </v-col>
                </v-row>
                <!-- <v-row>
                  <v-col cols="12" sm="12" md="12">
                      <v-file-input
                        accept="image/png, image/jpeg, image/bmp"
                        placeholder="Pick an Contact Image"
                        prepend-icon="mdi-camera"
                        label="Contact Image"
                        name="contactimage"
                        id="contactimage"
                      ></v-file-input>
                  </v-col>
                </v-row> -->
                <v-row>
                  <v-col cols="12" sm="12" md="12"> <h4 class="title">Contact Image</h4></v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6" sm="6">
                                            
                    <Cropper classname="cropper" :src="contactimage" @change="onChangeContactImage" :stencilProps="{aspectRatio: 1}"/>
                    
                    <v-row>
                      <v-col cols="12" md="12" sm="12" align="center">
                        <v-btn color="primary" @click="$refs.contactimgfile.click()"> 
                                                            
                          <input type="file" ref="contactimgfile" @change="contactim($event)" accept="image/*" class="d-none" id="contactimg"/> Upload Contact Image
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col col="12" md="6" sm="6">
                    <img style="max-width:100%"  :src="contactimg"  class="grey lighten-2"  max-height="300"  v-if="contactimg!=null" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <h4 class="title">Address Information</h4>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="addressLine1" name="addressLine1" label="Address Line1"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="addressLine2" name="addressLine2" label="Address Line2"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="addressLine3" name="addressLine3" label="City"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  
                  <v-col cols="12" md="4">
                    <v-text-field v-model="addressLine4" name="addressLine4" label="State/Province"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="country" name="country" label="Country"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="postcode" name="postcode" label="Postcode"></v-text-field>
                  </v-col>
                </v-row>
                <!-- <v-row>
                  <v-col cols="12" md="12" sm="12">
                    <v-label class="font-weight-bold">Short Description</v-label>
                  </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="12" sm="12">
                   
                     <editor
                      api-key="kmqk9zj3cswmwgz5j95fcwx8fh4nutj31o7ru7va5lxht7nk"
                      initialValue=""
                      v-model="shortdescription"
                      :init="editorConfigDescription"
                    ></editor>
                  </v-col>
                </v-row> -->
                <v-row>
                  <v-col cols="12" md="12" sm="12">
                    <v-label class="font-weight-bold">Business Description</v-label>
                  </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="12" sm="12">
                   
                     <editor
                      api-key="kmqk9zj3cswmwgz5j95fcwx8fh4nutj31o7ru7va5lxht7nk"
                      initialValue=""
                      v-model="description"
                      :init="editorConfigDescription"
                    ></editor>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <h4 class="title">Password Information</h4>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="password"
                      type="password"
                      name="password"
                      label="Password"
                      v-validate="'required|min:6'"
                      :error-messages="errors.collect('password')"
                      data-vv-name="password"
                      ref="password"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="password_confirmation"
                      type="password"
                      name="password_confirmation"
                      label="Confirm Password"
                      v-validate="'required|confirmed:password'"
                      :error-messages="errors.collect('password_confirmation')"
                      data-vv-name="password_confirmation"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <h4 class="title">Social Media Urls</h4>
                  </v-col>
                </v-row>
                
                

                  <v-card elevation="3" class="pa-3 mb-3">
                    <v-row v-for="(item, index) in socialmedia" :key="index">
                                            
                      <v-col cols="12" md="6" >
                                                       
                        <v-select 
                          label="Social Media Icon"
                          v-model="item.id"  
                          :name="'socialmedia_id['+index+']'"  
                          item-text="name"
                          item-value="id"
                          :items="socialmedias">
                                                          <template v-slot:selection="data">
                                                              <v-icon v-text="data.item.icon" class="mr-3"></v-icon>{{data.item.name}}
                                                          </template>
                                                          <template v-slot:item="data">
                                                              <v-icon v-text="data.item.icon" class="mr-3"></v-icon>{{data.item.name}}
                                                          </template>
                                                        </v-select>
                                                    </v-col>
                                                    <v-col cols="12" md="5" sm="5">
                                                        <v-text-field
                                                            v-model="item.value"
                                                            :name="'value['+index+']'"
                                                            label="Value"
                                                            >
                                                           
                                                        </v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" md="1" sm="1" justify="right" align="right">
                                                        <v-row class="">
                                                            <v-col cols="12" md="12" sm="12">
                                                                <a @click="socialmedia.splice(index, 1)"><v-icon  style="color:red">mdi-delete</v-icon></a>
                                                            </v-col>
                                                        </v-row>
                                                
                                                    </v-col>
                                                
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12" sm="12">
                        <v-btn class="add " color="primary" @click="add">Add Social Media</v-btn>
                      </v-col>
                    </v-row>
                                        
                  </v-card>

                
                <v-divider></v-divider>

                 <v-row>
                  <v-col cols="12" md="12">
                    <h4 class="title">Business Facilities</h4>
                  </v-col>
                </v-row>
                <v-card elevation="3" class="pa-3 mb-3">
                                        <v-row v-for="(item, index) in facilities" :key="index">
                                            
                                                    <v-col cols="12" md="4" >
                                                       
                                                      <v-select 
                                                          label="Facility Icon"
                                                          v-model="item.id"  
                                                          :name="'facilities_id['+index+']'"  
                                                          item-text="name"
                                                          item-value="id"
                                                          :items="facilitiy">
                                                          <template v-slot:selection="data">
                                                              <v-icon v-text="data.item.icon" class="mr-3"></v-icon>{{data.item.name}}
                                                          </template>
                                                          <template v-slot:item="data">
                                                              <v-icon v-text="data.item.icon" class="mr-3"></v-icon>{{data.item.name}}
                                                          </template>
                                                      </v-select>
                                                    </v-col>
                                                    <v-col cols="12" md="3" sm="3">
                                                        <v-text-field
                                                            v-model="item.link"
                                                            :name="'link['+index+']'"
                                                            label="Link"
                                                            >
                                                           
                                                        </v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" md="4" sm="4">
                                                        <v-text-field
                                                            v-model="item.description"
                                                            :name="'description['+index+']'"
                                                            label="Description"
                                                            >
                                                           
                                                        </v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" md="1" sm="1" justify="right" align="right">
                                                        <v-row class="">
                                                            <v-col cols="12" md="12" sm="12">
                                                                <a @click="facilities.splice(index, 1)"><v-icon  style="color:red">mdi-delete</v-icon></a>
                                                            </v-col>
                                                        </v-row>
                                                
                                                    </v-col>
                                                
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" md="12" sm="12">
                                                <v-btn class="add " color="primary" @click="addFacility">Add Facility</v-btn>
                                            </v-col>
                                        </v-row>
                                        
                 </v-card> 
                

                <v-divider></v-divider>

                <v-card elevation="3" class="pa-3 mb-3">
                  <v-row>
                    <v-col cols="12" md="12" sm="12">
                      <h3 class="text-center title red--text" color="">Star Rating</h3>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <!-- <v-col v-for="n in 5" :key="n" cols="auto" align="center">
                      <v-icon :color="star>=n?'red':''" @click="star=n">mdi-star-outline</v-icon>
                                                
                    </v-col> -->
                    <v-rating v-model="star" clearable="true"></v-rating>
                  </v-row>
                </v-card>
                <v-divider></v-divider>
                <v-row>
                  <v-col cols="12" md="12">
                    <h4 class="title">Working Hours</h4>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="4" md="4" sm="4">
                    <v-checkbox v-model="allwaysopen" label="Always Open" @click="setalwaysopen()" ></v-checkbox>
                  </v-col>
                  <v-col cols="4" md="4" sm="4">
                                              
                    <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px">
                        <template v-slot:activator="{ on }">
                                                        
                          <v-text-field
                              v-model="computedDateFormatted"
                              label="From Date"
                              prepend-icon="event"
                              hint="DD/MM/YYYY"
                              persistent-hint
                              readonly
                              v-on="on"
                              clearable
                              @click:clear="fromdate = null"
                          ></v-text-field>
                        </template>
                        <v-date-picker no-title v-model="fromdate" name="fromdate"  @input="menu2 = false"></v-date-picker>
                    </v-menu> 
                  </v-col>
                                        
                  <v-col cols="12" md="4" sm="4">
                                                
                    <v-menu v-model="menu3" :close-on-content-click="false" :nudge-right="40" 
                      transition="scale-transition" offset-y min-width="290px">
                      <template v-slot:activator="{ on }">
                                                        
                        <v-text-field
                            v-model="computedDateFormattedEnd"
                            label="Event End Date"
                            prepend-icon="event"
                            hint="DD/MM/YYYY"
                            persistent-hint
                            clearable
                              @click:clear="enddate = null"
                            readonly
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker no-title v-model="enddate" name="enddate"  @input="menu3 = false"></v-date-picker>
                    </v-menu> 
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="2" md="2" sm="2">
                    <strong>Day</strong>
                  </v-col>

                  <v-col cols="2" md="2" sm="2">
                    <strong>Copy</strong>
                  </v-col>

                  <v-col cols="2" md="2" sm="2">
                    <strong>Opening Hours</strong>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    <strong>Closing Hours</strong>
                  </v-col>

                  <v-col cols="2" md="2" sm="2">
                    <strong>Opening Hours</strong>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    <strong>Closing Hours</strong>
                  </v-col>

                </v-row>  

                <v-row>
                  <v-col cols="2" md="2" sm="2">
                    <strong>Monday</strong>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    
                    <a @click="mondayTime" class="teal " style="color:#fff !important;padding:5px;">Copy Below</a>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                     
                    <v-select 
                      label="Monday Opening"
                      v-model="mondayopening"  
                      name="mondayopening"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select>

                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    
                    <v-select 
                      label="Monday Closing"
                      v-model="mondayclosing"  
                      name="mondayclosing"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    <v-select 
                      label="Opening second Half"
                      v-model="mondayopening2"  
                      name="mondayopening2"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    <v-select 
                      label="Closing second Half"
                      v-model="mondayclosing2"  
                      name="mondayclosing2"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select>
                  </v-col>
                </v-row> 

                <v-row>
                  <v-col cols="2" md="2" sm="2">
                    <strong>Tuesday</strong>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    
                    <a @click="tuesdayTime" class="teal " style="color:#fff !important;padding:5px;">Copy Below</a>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                     
                    <v-select 
                      label="Tuesday Opening"
                      v-model="tuesdayopening"  
                      name="tuesdayopening"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    
                    <v-select 
                      label="Tuesday Closing"
                      v-model="tuesdayclosing"  
                      name="tuesdayclosing"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    
                    <v-select 
                      label="Opening Second Half"
                      v-model="tuesdayopening2"  
                      name="tuesdayopening2"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                   
                     <v-select 
                      label="Closing Second Half"
                      v-model="tuesdayclosing2"  
                      name="tuesdayclosing2"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select>
                  </v-col>
                </v-row> 

                <v-row>
                  <v-col cols="2" md="2" sm="2">
                    <strong>Wednesday</strong>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    
                    <a @click="wednesdayTime" class="teal " style="color:#fff !important;padding:5px;">Copy Below</a>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    <!-- <v-text-field
                      v-model="wednesdayopening"
                      type="text"
                      name="wednesdayopening"
                      label="Wednesday Opening"
                    ></v-text-field> -->

                    <v-select 
                      label="Wednesday Opening"
                      v-model="wednesdayopening"  
                      name="wednesdayopening"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    

                    <v-select 
                      label="Wednesday Closing"
                      v-model="wednesdayclosing"  
                      name="wednesdayclosing"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    

                    <v-select 
                      label="Opening Second Half"
                      v-model="wednesdayopening2"  
                      name="wednesdayopening2"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                   

                     <v-select 
                      label="Closing Second Half"
                      v-model="wednesdayclosing2"  
                      name="wednesdayclosing2"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select> 

                  </v-col>
                </v-row> 

                <v-row>
                  <v-col cols="2" md="2" sm="2">
                    <strong>Thursday</strong>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    
                    <a @click="thuesdayTime" class="teal " style="color:#fff !important;padding:5px;">Copy Below</a>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    
                     <v-select 
                      label="Thursday Opening"
                      v-model="thursdayopening"  
                      name="thursdayopening"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    <!-- <v-text-field
                      v-model="thursdayclosing"
                      type="text"
                      name="thursdayclosing"
                      label="Thursday Closing"
                     
                    ></v-text-field> -->

                    <v-select 
                      label="Thursday Closing"
                      v-model="thursdayclosing"  
                      name="thursdayclosing"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    
                    <v-select 
                      label="Opening Second Half"
                      v-model="thursdayopening2"  
                      name="thursdayopening2"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    
                    <v-select 
                      label="Closing Second Half"
                      v-model="thursdayclosing2"  
                      name="thursdayclosing2"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select>
                  </v-col>
                </v-row>  

                <v-row>
                  <v-col cols="2" md="2" sm="2">
                    <strong>Friday</strong>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    <a @click="fridayTime" class="teal" style="color:#fff !important;padding:5px;">Copy Below</a>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    
                    <v-select 
                      label="Friday Opening"
                      v-model="fridayopening"  
                      name="fridayopening"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                   
                    <v-select 
                      label="Friday Closing"
                      v-model="fridayclosing"  
                      name="fridayclosing"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select>
                  </v-col>
                   <v-col cols="2" md="2" sm="2">
                    
                    <v-select 
                      label="Opening Second Half"
                      v-model="fridayopening2"  
                      name="fridayopening2"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                   
                     <v-select 
                      label="Closing Second Half"
                      v-model="fridayclosing2"  
                      name="fridayclosing2"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select>
                  </v-col>
                </v-row> 

                <v-row>
                  <v-col cols="2" md="2" sm="2">
                    <strong>Saturday</strong>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    <a @click="saturdayTime" class="teal" style="color:#fff !important;padding:5px;">Copy Below</a>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    
                    <v-select 
                      label="Saturday Opening"
                      v-model="saturdayopening"  
                      name="saturdayopening"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                   
                    <v-select 
                      label="Saturday Closing"
                      v-model="saturdayclosing"  
                      name="saturdayclosing"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    
                     <v-select 
                      label="Second Half Opening"
                      v-model="saturdayopening2"  
                      name="saturdayopening2"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                   
                    <v-select 
                      label="Second Half Closing"
                      v-model="saturdayclosing2"  
                      name="saturdayclosing2"  
                      item-text="name"
                      item-value="value" 
                      :items="times"  
                      :disabled="allwaysopen"
                    ></v-select>
                  </v-col>
                </v-row> 

                 <v-row>
                      <v-col cols="4" md="4" sm="4">
                        <strong>Sunday</strong>
                      </v-col>
                      <v-col cols="2" md="2" sm="2">
                        
                        <v-select 
                          label="Sunday Opening"
                          v-model="sundayopening"  
                          name="sundayopening"  
                          item-text="name"
                          item-value="value" 
                          :items="times"  
                          :disabled="allwaysopen"
                        ></v-select>
                      </v-col>
                      <v-col cols="2" md="2" sm="2">
                       
                         <v-select 
                          label="Sunday Closing"
                          v-model="sundayclosing"  
                          name="sundayclosing"  
                          item-text="name"
                          item-value="value" 
                          :items="times"  
                          :disabled="allwaysopen"
                        ></v-select>

                      </v-col>
                      <v-col cols="2" md="2" sm="2">
                      
                        <v-select 
                          label="Sunday Opening"
                          v-model="sundayopening2"  
                          name="sundayopening2"  
                          item-text="name"
                          item-value="value" 
                          :items="times"  
                          :disabled="allwaysopen"
                        ></v-select>
                      </v-col>
                      <v-col cols="2" md="2" sm="2">
                       
                        <v-select 
                          label="Sunday Closing"
                          v-model="sundayclosing2"  
                          name="sundayclosing2"  
                          item-text="name"
                          item-value="value" 
                          :items="times"  
                          :disabled="allwaysopen"
                        ></v-select>
                      </v-col>
                 </v-row> 
                 <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="openinghoursother"
                      type="text"
                      name="openinghoursother"
                      label="Opening Hours Other"
                     
                    ></v-text-field>
                  </v-col>
                </v-row>  
                <v-row>
                  <v-col cols="12" md="12">
                    <h4 class="title">Business Notes</h4>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-textarea
                      name="businessnotes"
                      label="Business Notes"
                      v-model="businessnotes"
                      hint="Enter business notes"
                    ></v-textarea>
                  </v-col>
                </v-row>  
                <v-row>
                  <v-col cols="12" md="12">
                    <h4 class="title">Business Logo</h4>
                  </v-col>
                </v-row>
                
                 <v-row>
                  <v-col cols="12" md="12">
                    <h4 class="title">Gallery</h4>
                  </v-col>
                </v-row>
                
                

                  <v-card elevation="3" class="pa-3 mb-3">

                  
                    <v-row v-for="(item, index) in galleries" :key="index">
                                            
                      <v-col cols="12" md="11">
                       
                               
                        <v-file-input
                          accept="image/png, image/jpeg, image/bmp"
                          placeholder="Pick an Gallery Image"
                          prepend-icon="mdi-camera"
                          label="Gallery Image"
                          :id="'img'+index"
                          :name="'imageurl['+index+']'"
                          
                        ></v-file-input>
                                         
                      </v-col>
                                                    
                      <v-col cols="12" md="1" sm="1" justify="right" align="right">
                        <v-row class="">
                          <v-col cols="12" md="12" sm="12">
                            <a @click="galleries.splice(index, 1)"><v-icon  style="color:red">mdi-delete</v-icon></a>
                          </v-col>
                        </v-row>
                                                
                      </v-col>
                                                
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12" sm="12">
                        <v-btn class="add " color="primary" @click="addgallery">Add Gallery</v-btn>
                      </v-col>
                    </v-row>
                                        
                  </v-card>

                
                  <v-divider></v-divider>
                <v-row>
                  <v-col cols="12" md="12">
                    <h4 class="title">Business Logo</h4>
                  </v-col>
                </v-row>
                <v-row>    
                  
                  <v-col cols="12" md="6" sm="6">
                                            
                    <Cropper classname="cropper" :src="uploadedimage" @change="onChange"/>
                    
                    <v-row>
                      <v-col cols="12" md="12" sm="12" align="center">
                        <v-btn color="primary" @click="$refs.file.click()"> 
                                                            
                          <input type="file" ref="file" @change="uploadImage($event)" accept="image/*" class="d-none" id="logo"/> Upload Image
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col col="12" md="6" sm="6">
                    <img style="max-width:100%"  :src="image"  class="grey lighten-2"  max-height="300"  v-if="image!=null" />
                  </v-col>
                </v-row>        
                
                <v-divider></v-divider>
                 <v-row>
                  <v-col cols="12" sm="12" md="12"> <h4 class="title">Background Image</h4></v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6" sm="6">
                                            
                    <Cropper classname="cropper" :src="backgroundimage" @change="onChangeBackground" :stencilProps="{aspectRatio: 9/16}"/>
                    
                    <v-row>
                      <v-col cols="12" md="12" sm="12" align="center">
                        <v-btn color="primary" @click="$refs.bfile.click()"> 
                                                            
                          <input type="file" ref="bfile" @change="backgroundImage($event)" accept="image/*" class="d-none" id="bimage"/> Upload Image
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col col="12" md="6" sm="6">
                    <img style="max-width:100%"  :src="bimage"  class="grey lighten-2"  max-height="300"  v-if="bimage!=null" />
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                  <v-col cols="12" sm="12" md="12"> <h4 class="title">OverView Image Section</h4></v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12" sm="12">
                      <v-text-field
                        v-model="overviewimagetitle"
                        name="overviewimagetitle"
                        label="Overview Title"></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12" sm="12">
                    
                      <v-textarea
                      v-model="overviewimagedescription"
                      name="overviewimagedescription"
                      label="Over View Description">
                      </v-textarea>
                  </v-col>

                </v-row>
                <v-row>
                    <v-col cols="12" md="6" sm="6">
                                            
                    <Cropper classname="cropper" :src="overviewimage" @change="onChangeOverView
                    ($event)" :stencilProps="{aspectRatio: 16/9}"/>
                    
                    <v-row>
                      <v-col cols="12" md="12" sm="12" align="center">
                        <v-btn color="primary" @click="$refs.overfile.click()"> 
                                                            
                          <input type="file" ref="overfile" @change="overimg($event)" accept="image/*" class="d-none" id="overimage"/> Upload Image
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col col="12" md="6" sm="6">
                    <img style="max-width:100%"  :src="overimage"  class="grey lighten-2"  max-height="300"  v-if="overimage!=null" />
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                 <v-row>
                  <v-col cols="12" sm="12" md="12"> <h4 class="title">Things To Do Image Section</h4></v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12" sm="12">
                      <v-text-field
                        v-model="thingsimagetitle"
                        name="thingsimagetitle"
                        label="Things Title"></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12" sm="12">
                    
                      <v-textarea
                      v-model="thingsimagedescription"
                      name="thingsimagedescription"
                      label="Things Description">
                      </v-textarea>
                  </v-col>

                </v-row>
                <v-row>
                    <v-col cols="12" md="6" sm="6">
                                            
                    <Cropper classname="cropper" :src="thingstodoimage" @change="onChangeThingsView($event)" :stencilProps="{aspectRatio: 16/9}"/>
                    
                    <v-row>
                      <v-col cols="12" md="12" sm="12" align="center">
                        <v-btn color="primary" @click="$refs.thingsfile.click()"> 
                                                            
                          <input type="file" ref="thingsfile" @change="thingsimg($event)" accept="image/*" class="d-none" id="tingsimage"/> Upload Image
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col col="12" md="6" sm="6">
                    <img style="max-width:100%"  :src="tingsimage"  class="grey lighten-2"  max-height="300"  v-if="tingsimage!=null" />
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                  <v-col cols="12" sm="12" md="12"> <h4 class="title">Team Image</h4></v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12" sm="12">
                      <v-text-field
                        v-model="teamimagetitle"
                        name="teamimagetitle"
                        label="Team Title"></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12" sm="12">
                    
                    <v-textarea
                      v-model="teamimagedescription"
                      name="teamimagedescription"
                      label="Team Description">
                    </v-textarea>
                  </v-col>

                </v-row>
                <v-row>
                    <v-col cols="12" md="6" sm="6">
                                            
                    <Cropper classname="cropper" :src="teamimage" @change="onChangeTeam($event)" :stencilProps="{aspectRatio: 16/9}"/>
                    
                    <v-row>
                      <v-col cols="12" md="12" sm="12" align="center">
                        <v-btn color="primary" @click="$refs.teamfile.click()"> 
                                                            
                          <input type="file" ref="teamfile" @change="teamim($event)" accept="image/*" class="d-none" id="teamimg"/> Upload Image
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col col="12" md="6" sm="6">
                    <img style="max-width:100%"  :src="teamimg"  class="grey lighten-2"  max-height="300"  v-if="teamimg!=null" />
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                  <v-col cols="12" sm="12" md="12"> <h4 class="title">Love Image</h4></v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12" sm="12">
                      <v-text-field
                        v-model="loveimagetitle"
                        name="loveimagetitle"
                        label="Love Title"></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12" sm="12">
                    
                    <v-textarea
                      v-model="loveimagedescription"
                      name="loveimagedescription"
                      label="Love Description">
                    </v-textarea>
                  </v-col>

                </v-row>
                <v-row>
                    <v-col cols="12" md="6" sm="6">
                                            
                    <Cropper classname="cropper" :src="loveimage" @change="onChangeLove($event)" :stencilProps="{aspectRatio: 16/9}"/>
                    
                    <v-row>
                      <v-col cols="12" md="12" sm="12" align="center">
                        <v-btn color="primary" @click="$refs.lovefile.click()"> 
                                                            
                          <input type="file" ref="lovefile" @change="loveim($event)" accept="image/*" class="d-none" id="loveimg"/> Upload Image
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col col="12" md="6" sm="6">
                    <img style="max-width:100%"  :src="loveimg"  class="grey lighten-2"  max-height="300"  v-if="loveimg!=null" />
                  </v-col>
                </v-row>
                <v-divider></v-divider>


                <v-row>
                  <v-col cols="12" md="12" sm="12">
                    
                    <v-textarea
                      v-model="whatsapmsg"
                      name="whatsapmsg"
                      label="Whatsap Msg">
                    </v-textarea>
                  </v-col>
                </v-row>

                <v-divider></v-divider>
                  <v-row>
                    <v-col cols="12" sm="12" md="12"> 
                      <h4 class="title">Navigation Section</h4>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6" sm="6" md="6"> 
                      <v-text-field v-model="homeicon" name="homeicon" label="Home Icon"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6"> 
                      <v-text-field v-model="hometitle" name="hometitle" label="Home Title"></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6" sm="6" md="6"> 
                      <v-text-field v-model="eventicon" name="eventicon" label="Event Icon"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6"> 
                      <v-text-field v-model="eventtitle" name="eventtitle" label="Event Title"></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6" sm="6" md="6"> 
                      <v-text-field v-model="teamicon" name="teamicon" label="Team Icon"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6"> 
                      <v-text-field v-model="teamtitle" name="teamtitle" label="Team Title"></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6" sm="6" md="6"> 
                      <v-text-field v-model="loveicon" name="loveicon" label="Love Icon"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6"> 
                      <v-text-field v-model="lovetitle" name="lovetitle" label="Love Title"></v-text-field>
                    </v-col>
                  </v-row>
                <div class="my-3">
                  <v-btn color="primary" @click="submit">Create Business</v-btn>
                </div>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Vue from "vue";
  import VeeValidate from "vee-validate";
  import Editor from '@tinymce/tinymce-vue'
  import { Cropper } from 'vue-advanced-cropper'

  Vue.use(VeeValidate);
  export default {
  
  props: {
    source: String
  },
  data: vm => 
  ({
      homeicon:'',
      hometitle:'',
      eventicon:'',
      eventtitle:'',
      teamicon:'',
      teamtitle:'',
      loveicon:'',
      lovetitle:'',
      whatsapmsg:'',
      
    overlay: false,
    fromdate: null,
    //enddate: new Date().toISOString().substr(0, 10),   
    enddate:null,
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)), 
    menu3: false, 
    menu2: false, 
    welcomemsg:'',
   
    
    socialmedia_id:"",
    socialmedia:[{'id':'','socialmedia':'','value':''}],
    socialmedias:[],
    creater_id:"",
    agents:[],
    openinghoursother:"",
    allwaysopen:false,
    currency:"",
    currencies:[],
    country:"",

    ownername:"",
    ownerposition:"",
    mobile:"",
    whatsapp:"",
    website:"",
    instagram:"",
    twitter:"",
    mondayopening:"0",
    mondayclosing:"0",
    tuesdayopening:"0",
    tuesdayclosing:"0",
    wednesdayopening:"0",
    wednesdayclosing:"0",
    thursdayopening:"0",
    thursdayclosing:"0",
    fridayopening:"0",
    fridayclosing:"0",
    saturdayopening:"0",
    saturdayclosing:"0",
    sundayopening:"0",
    sundayclosing:"0",
    mondayopening2:"0",
    mondayclosing2:"0",
    tuesdayopening2:"0",
    tuesdayclosing2:"0",
    wednesdayopening2:"0",
    wednesdayclosing2:"0",
    thursdayopening2:"0",
    thursdayclosing2:"0",
    fridayopening2:"0",
    fridayclosing2:"0",
    saturdayopening2:"0",
    saturdayclosing2:"0",
    sundayopening2:"0",
    sundayclosing2:"0",
    valid: true,
    businessName: "",
    businessType: "",
    numberOfEmployees: "",
    email: "",
    phone: "",
    contactName:"",
    contactPosition:"",
    contactEmail:"",
    contactPhone:"",
    password: "",
    password_confirmation: "",
    addressLine1: "",
    addressLine2: "",
    addressLine3: "",
    addressLine4: "",
    postcode: "",
    facebook:"",
    tripadvisor:"",
    linkedin:"",
    businessnotes:"",
    googlemaps:"",
    storeBusiness: [],
    types: [],
    times:[{name:"Allways Open",value:"allwaysopen"},
           {name:"Closed",value:"0"},
           {name:"00:00",value:"00:00"},
           {name:"00:30",value:"00:30"},
           {name:"01:00",value:"01:00"},
           {name:"01:30",value:"01:30"},
           {name:"02:00",value:"02:00"},
           {name:"02:30",value:"02:30"},
           {name:"03:00",value:"03:00"},
           {name:"03:30",value:"03:30"},
           {name:"04:00",value:"04:00"},
           {name:"04:30",value:"04:30"},
           {name:"05:00",value:"05:00"},
           {name:"05:30",value:"05:30"},
           {name:"06:00",value:"06:00"},
           {name:"06:30",value:"06:30"},
           {name:"07:00",value:"07:00"},
           {name:"07:30",value:"07:30"},
           {name:"08:00",value:"08:00"},
           {name:"08:30",value:"08:30"},
           {name:"09:00",value:"09:00"},
           {name:"09:30",value:"09:30"},
           {name:"10:00",value:"10:00"},
           {name:"10:30",value:"10:30"},
           {name:"11:00",value:"11:00"},
           {name:"11:30",value:"11:30"},
           {name:"12:00",value:"12:00"}, 
           {name:"12:30",value:"12:30"},
           {name:"13:00",value:"13:00"},
           {name:"13:30",value:"13:30"},
           {name:"14:00",value:"14:00"},
           {name:"14:30",value:"14:30"},
           {name:"15:00",value:"15:00"},
           {name:"15:30",value:"15:30"}, 
           {name:"16:00",value:"16:00"},
           {name:"16:30",value:"16:30"},
           {name:"17:00",value:"17:00"},
           {name:"17:30",value:"17:30"}, 
           {name:"18:00",value:"18:00"},
           {name:"18:30",value:"18:30"}, 
           {name:"19:00",value:"19:00"},
           {name:"19:30",value:"19:30"}, 
           {name:"20:00",value:"20:00"},
           {name:"20:30",value:"20:30"}, 
           {name:"21:00",value:"21:00"}, 
           {name:"21:30",value:"21:30"}, 
           {name:"22:00",value:"22:00"}, 
           {name:"22:30",value:"22:30"},
           {name:"23:00",value:"23:00"}, 
           {name:"23:30",value:"23:30"}],
    dictionary: {
      attributes: {
        email: "E-mail Address",
        businessName: "Business Name",
        businessType: "Business Type",
        // custom attributes
      },
      custom: {}
    },
    uploadedimage:null,
    backgroundimage:null,
    image:null,
    bimage:null,
    coordinates: {
				width: 0,
				height: 0,
				left: 0,
				top: 0
    },
    businessactivities:[],
    businessactivity_id:0,
    facilities:[{'id':'','facility':'','link':'','description':''}],
    facilitiy:[],
    facilities_id:"",
    star:0,
    galleries:[{'imageurl':''}],
    imageurl:'',
    files: [],
    description:'',
    overviewimage:null,
    overimage:null,
    thingstodoimage:null,
    tingsimage:null,
    teamimage:null,
    teamimg:null,
    loveimage:null,
    loveimg:null,
    contactimg:null,
    contactimage:null,
    editorData: '',
    editorConfig: { height: 100,
         menubar: false,
         plugins: [
           'advlist autolink lists link image charmap print preview anchor',
           'searchreplace visualblocks code fullscreen',
           'insertdatetime media table paste code wordcount autoresize'
         ],
         toolbar:
           'undo redo | bold italic | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | link image anchor'}, 
         editorConfigDescription: {height: 100,
         menubar: false,
         plugins: [
           'advlist autolink lists link image charmap print preview anchor',
           'searchreplace visualblocks code fullscreen',
           'insertdatetime media table paste code wordcount autoresize'
         ],
         toolbar:
           'undo redo | formatselect | bold italic forecolor backcolor| \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | link image anchor'},   
      shortdescription:'',    
      overviewimagetitle:'',
      overviewimagedescription:'',
      thingsimagetitle:'',
      thingsimagedescription:'',
      teamimagetitle:'',
      teamimagedescription:'',
      loveimagetitle:'',
      loveimagedescription:'',
  }),
  
  mounted() {
    this.$validator.localize("en", this.dictionary);
  },
  computed: {
    isAuthorised() {
      return this.$store.getters.isLoggedin;
    },
    computedDateFormatted () 
    {
         return this.formatDate(this.fromdate)
    },
      
    computedDateFormattedEnd()
    {
      return this.formatDate(this.enddate)
    },
  },
  watch: 
    {
      fromdate (val) {
        this.dateFormatted = this.formatDate(this.fromdate)
      },
      enddate(val)
      {
        this.dateFormatted = this.formatDate(this.enddate)
      }
    },
  components: {
    'editor': Editor,
    Cropper
	},
  created() {
    this.fetchBusinessType();
    this.fetchCurrency();
    this.fetchAgent();
    this.fetchSocialMedia();
    this.fetchBusinessActivity(); 
    this.fetchFacilities();
  },
  methods: {
    formatDate (date) 
    {
            if (!date) return null

            const [year,month,day ] = date.split('-')
            return `${day}/${month}/${year}`
    },
    parseDate (date) 
    {
            if (!date) return null

            const [ day, month,year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    setalwaysopen()
    {
        if(this.allwaysopen)
        {
            this.mondayopening='allwaysopen';
            this.mondayclosing='allwaysopen';
            this.mondayopening2='allwaysopen';
            this.mondayclosing2='allwaysopen';

            this.tuesdayopening='allwaysopen';
            this.tuesdayclosing='allwaysopen';
            this.tuesdayopening2='allwaysopen';
            this.tuesdayclosing2='allwaysopen';

            this.wednesdayopening='allwaysopen';
            this.wednesdayclosing='allwaysopen';
            this.wednesdayopening2='allwaysopen';
            this.wednesdayclosing2='allwaysopen';

            this.thursdayopening='allwaysopen';
            this.thursdayclosing='allwaysopen';
            this.thursdayopening2='allwaysopen';
            this.thursdayclosing2='allwaysopen';

            this.fridayopening='allwaysopen';
            this.fridayclosing='allwaysopen';
            this.fridayopening2='allwaysopen';
            this.fridayclosing2='allwaysopen';

            this.saturdayopening='allwaysopen';
            this.saturdayclosing='allwaysopen';
            this.saturdayopening2='allwaysopen';
            this.saturdayclosing2='allwaysopen';

            this.sundayopening='allwaysopen';
            this.sundayclosing='allwaysopen';
            this.sundayopening2='allwaysopen';
            this.sundayclosing2='allwaysopen';


        }else{
            this.mondayopening='0';
            this.mondayclosing='0';
            this.mondayopening2='0';
            this.mondayclosing2='0';

            this.tuesdayopening='0';
            this.tuesdayclosing='0';
            this.tuesdayopening2='0';
            this.tuesdayclosing2='0';

            this.wednesdayopening='0';
            this.wednesdayclosing='0';
            this.wednesdayopening2='0';
            this.wednesdayclosing2='0';

            this.thursdayopening='0';
            this.thursdayclosing='0';
            this.thursdayopening2='0';
            this.thursdayclosing2='0';

            this.fridayopening='0';
            this.fridayclosing='0';
            this.fridayopening2='0';
            this.fridayclosing2='0';

            this.saturdayopening='0';
            this.saturdayclosing='0';
            this.saturdayopening2='0';
            this.saturdayclosing2='0';

            this.sundayopening='0';
            this.sundayclosing='0';
            this.sundayopening2='0';
            this.sundayclosing2='0';


        }
    },
    saturdayTime()
    {
           this.sundayopening=this.saturdayopening;
           
           
           this.sundayclosing=this.saturdayclosing;

           
           this.sundayopening2=this.saturdayopening2;

           this.sundayclosing2=this.saturdayclosing2;
    },
    fridayTime()
    {
           this.saturdayopening=this.fridayopening;
           //this.sundayopening=this.fridayopening;
           
           
           this.saturdayclosing=this.fridayclosing;
           //this.sundayclosing=this.fridayclosing;

           
           this.saturdayopening2=this.fridayopening2;
           //this.sundayopening2=this.fridayopening2;

           this.saturdayclosing2=this.fridayclosing2;
           //this.sundayclosing2=this.fridayclosing2;
    },
    thuesdayTime()
    {
           this.fridayopening=this.thursdayopening;
          //  this.saturdayopening=this.thursdayopening;
          //  this.sundayopening=this.thursdayopening;
           
           
           this.fridayclosing=this.thursdayclosing;
          //  this.saturdayclosing=this.thursdayclosing;
          //  this.sundayclosing=this.thursdayclosing;

           
           this.fridayopening2=this.thursdayopening2;
          //  this.saturdayopening2=this.thursdayopening2;
          //  this.sundayopening2=this.thursdayopening2;

           this.fridayclosing2=this.thursdayclosing2;
          //  this.saturdayclosing2=this.thursdayclosing2;
          //  this.sundayclosing2=this.thursdayclosing2;
    },
    wednesdayTime()
    {
           
           this.thursdayopening=this.wednesdayopening;
          //  this.fridayopening=this.wednesdayopening;
          //  this.saturdayopening=this.wednesdayopening;
          //  this.sundayopening=this.wednesdayopening;
           
           
           this.thursdayclosing=this.wednesdayclosing;
          //  this.fridayclosing=this.wednesdayclosing;
          //  this.saturdayclosing=this.wednesdayclosing;
          //  this.sundayclosing=this.wednesdayclosing;

           
           this.thursdayopening2=this.wednesdayopening2;
          //  this.fridayopening2=this.wednesdayopening2;
          //  this.saturdayopening2=this.wednesdayopening2;
          //  this.sundayopening2=this.wednesdayopening2;

           this.thursdayclosing2=this.wednesdayclosing2;
          //  this.fridayclosing2=this.wednesdayclosing2;
          //  this.saturdayclosing2=this.wednesdayclosing2;
          //  this.sundayclosing2=this.wednesdayclosing2;
    },
    tuesdayTime()
    {
           
           this.wednesdayopening=this.tuesdayopening;
          //  this.thursdayopening=this.tuesdayopening;
          //  this.fridayopening=this.tuesdayopening;
          //  this.saturdayopening=this.tuesdayopening;
          //  this.sundayopening=this.tuesdayopening;
           
           
           this.wednesdayclosing=this.tuesdayclosing;
          //  this.thursdayclosing=this.tuesdayclosing;
          //  this.fridayclosing=this.tuesdayclosing;
          //  this.saturdayclosing=this.tuesdayclosing;
          //  this.sundayclosing=this.tuesdayclosing;

           
           this.wednesdayopening2=this.tuesdayopening2;
          //  this.thursdayopening2=this.tuesdayopening2;
          //  this.fridayopening2=this.tuesdayopening2;
          //  this.saturdayopening2=this.tuesdayopening2;
          //  this.sundayopening2=this.tuesdayopening2;

           this.wednesdayclosing2=this.tuesdayclosing2;
          //  this.thursdayclosing2=this.tuesdayclosing2;
          //  this.fridayclosing2=this.tuesdayclosing2;
          //  this.saturdayclosing2=this.tuesdayclosing2;
          //  this.sundayclosing2=this.tuesdayclosing2;
    },
    mondayTime()
    { 
       
           this.tuesdayopening=this.mondayopening;
          //  this.wednesdayopening=this.mondayopening;
          //  this.thursdayopening=this.mondayopening;
          //  this.fridayopening=this.mondayopening;
          //  this.saturdayopening=this.mondayopening;
          //  this.sundayopening=this.mondayopening;
           
           this.tuesdayclosing=this.mondayclosing;
          //  this.wednesdayclosing=this.mondayclosing;
          //  this.thursdayclosing=this.mondayclosing;
          //  this.fridayclosing=this.mondayclosing;
          //  this.saturdayclosing=this.mondayclosing;
          //  this.sundayclosing=this.mondayclosing;

           this.tuesdayopening2=this.mondayopening2;
          //  this.wednesdayopening2=this.mondayopening2;
          //  this.thursdayopening2=this.mondayopening2;
          //  this.fridayopening2=this.mondayopening2;
          //  this.saturdayopening2=this.mondayopening2;
          //  this.sundayopening2=this.mondayopening2;

           this.tuesdayclosing2=this.mondayclosing2;
          //  this.wednesdayclosing2=this.mondayclosing2;
          //  this.thursdayclosing2=this.mondayclosing2;
          //  this.fridayclosing2=this.mondayclosing2;
          //  this.saturdayclosing2=this.mondayclosing2;
          //  this.sundayclosing2=this.mondayclosing2;
   
    },
    fetchAgent()
    {
      this.$http
      .get(this.$apidomain+"agent/agentlistspecial/"+this.$user.id)
      .then(res => {
        this.agents = res.data.agents;
        //console.log(this.agents[0]);
        this.creater_id=this.agents[0].user_id;
      })
      .catch(err => {
        console.log(err.response);
      });
    },
    fetchSocialMedia()
    {
      this.$http
            .get(this.$apidomain+"socialmedialist")
            .then(res => {
                this.socialmedias = res.data.socialmedia;
            })
            .catch(err => {
                console.log(err.response);
      });
    },
    fetchCurrency()
    {
      this.$http
      .get(this.$apidomain+"agent/currencylist")
      .then(res => {
        this.currencies = res.data.currencies;
        //console.log("types "+ this.types);
      })
      .catch(err => {
        console.log(err.response);
      });
    },
    fetchBusinessType()
    {
      this.$http
      .get(this.$apidomain+"agent/businesstypelist")
      .then(res => {
        this.types = res.data.businessType;
        //console.log("types "+ this.types);
      })
      .catch(err => {
        console.log(err.response);
      });
    },
    fetchFacilities()
    {
          this.$http
          .get(this.$apidomain+"facilitiesList")
          .then(res => {
          this.facilitiy = res.data.facilities;
          })
          .catch(err => {
            console.log(err.response);
          });
    },
    fetchBusinessActivity()
    {
      this.$http
      .get(this.$apidomain+"businessActivityList")
      .then(res => {
      this.businessactivities = res.data.businessActivities;
      })
      .catch(err => {
      console.log(err.response);
      });
    },
    add()
    {
      this.socialmedia.push({
      'id':'',
      'socialmedia':'',
      'value':''
      })
    },
    addFacility()
    {
        
      this.facilities.push({
        'id':'',
        'facility':'',
        'link':'',
        'description':''

      })
    },
    addgallery()
    {
         this.galleries.push({'imageurl':''})
    },
    onChange({coordinates, canvas}) {
            
			this.coordinates = coordinates
			// You able to do different manipulations at a canvas
			// but there we just get a cropped image
			this.image = canvas.toDataURL()
    },
    onChangeContactImage({coordinates, canvas})
    {
      this.coordinates = coordinates
      this.contactimg = canvas.toDataURL()
    },
    onChangeBackground({coordinates, canvas})
    {
      this.coordinates = coordinates
      this.bimage = canvas.toDataURL()
    },
    onChangeOverView({coordinates, canvas})
    {
      this.coordinates = coordinates
      this.overimage = canvas.toDataURL()
    },
    onChangeThingsView({coordinates, canvas})
    {
      this.coordinates = coordinates
      this.tingsimage = canvas.toDataURL()
    },
    onChangeTeam({coordinates, canvas})
    {
      this.coordinates = coordinates
      
      this.teamimg = canvas.toDataURL()
    },
    onChangeLove({coordinates, canvas})
    {
      this.coordinates = coordinates
        
      this.loveimg = canvas.toDataURL()
    },
    uploadImage(event) {
			// Reference to the DOM input element
			var input = event.target;
			// Ensure that you have a file before attempting to read it
			if (input.files && input.files[0]) {
					// create a new FileReader to read this image and convert to base64 format
					var reader = new FileReader();
					// Define a callback function to run, when FileReader finishes its job
					reader.onload = (e) => {
							// Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
							// Read image as base64 and set to imageData
							this.uploadedimage = e.target.result;
					}
					// Start the reader job - read file as a data url (base64 format)
					reader.readAsDataURL(input.files[0]);
			}
    },
    backgroundImage(event)
    {
      var input = event.target;
        // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.backgroundimage = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }

    },
    overimg(event)
    {
      var input = event.target;
        // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) 
      {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.overviewimage = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
      }

    },
    thingsimg(event)
    {
      var input = event.target;
        // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) 
      {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
        // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
        this.thingstodoimage = e.target.result;
        }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
      }
    },
    teamim(event)
    {
      var input = event.target;
        // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) 
      {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.teamimage = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
      }
    },
    loveim(event)
    {
      var input = event.target;
        // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.loveimage = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },
    contactim(event)
    {
      var input = event.target;
        // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) 
      {
            // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.contactimage = e.target.result;
          }
          // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    dataURLtoFile(dataurl, filename) 
    {
 
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), 
                n = bstr.length, 
                u8arr = new Uint8Array(n);
                
            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }
        
            return new File([u8arr], filename, {type:mime});
    },
    submit() {
      let th = this;
      if (this.$validator.validateAll()) {
        let fd = new FormData(document.getElementById("createbusiness"));
        fd.append('businessactivity_id',this.businessactivity_id);
        fd.append('starrating',this.star);
        fd.append('fromdate',this.fromdate);
        fd.append('enddate',this.enddate);

        if(this.contactimage!=null)
        {
          fd.append('contactimage',this.dataURLtoFile(this.contactimg,document.getElementById('contactimg').files[0].name));    
        }

        if(this.uploadedimage!=null)
        {
        fd.append('imagea',this.dataURLtoFile(this.image,document.getElementById('logo').files[0].name));    
        }

        if(this.backgroundimage!=null)
        {
          fd.append('bimage',this.dataURLtoFile(this.bimage,document.getElementById('bimage').files[0].name));    
        }

        if(this.overviewimage!=null)
        {
          fd.append('overviewimage',this.dataURLtoFile(this.overimage,document.getElementById('overimage').files[0].name));    
        }

        if(this.tingsimage!=null)
        {
          fd.append('thingsimage',this.dataURLtoFile(this.tingsimage,document.getElementById('tingsimage').files[0].name));    
        }

        if(this.loveimg!=null)
        {
          fd.append('loveimage',this.dataURLtoFile(this.loveimg,document.getElementById('loveimg').files[0].name));    
        }

        if(this.teamimg!=null)
        {
          fd.append('teamimage',this.dataURLtoFile(this.teamimg,document.getElementById('teamimg').files[0].name));    
        }

        fd.append('welcomemsg',this.welcomemsg);

        fd.append('description',this.description);

        fd.append('shortdescription',this.shortdescription);

        fd.append('socialmedias',JSON.stringify(this.socialmedia));
        fd.append('facilities',JSON.stringify(this.facilities));

        // let imgCount=0;
        //   this.galleries.forEach(function(it){
        //       fd.append('imageurl[]',document.getElementById('img'+imgCount).files[0]);
        //       imgCount++;
        //   });

        if(this.creater_id!='')
        {
          fd.append('creater_id',this.creater_id);
        }  

        fd.append("allwaysopen",(this.allwaysopen?1:0));

        
        fd.append("businessType", this.businessType);

        fd.append('currency_id',this.currency);
        
        fd.append("businessType", this.businessType);

       
        fd.append("mondayopening",this.mondayopening);
        fd.append("mondayclosing",this.mondayclosing);
        fd.append("mondayopening2",this.mondayopening2);
        fd.append("mondayclosing2",this.mondayclosing2);

        fd.append("tuesdayopening",this.tuesdayopening);
        fd.append("tuesdayclosing",this.tuesdayclosing);
        fd.append("tuesdayopening2",this.tuesdayopening2);
        fd.append("tuesdayclosing2",this.tuesdayclosing2);


        fd.append("wednesdayopening",this.wednesdayopening);
        fd.append("wednesdayclosing",this.wednesdayclosing);
        fd.append("wednesdayopening2",this.wednesdayopening2);
        fd.append("wednesdayclosing2",this.wednesdayclosing2);

        fd.append("thursdayopening",this.thursdayopening);
        fd.append("thursdayclosing",this.thursdayclosing);
        fd.append("thursdayopening2",this.thursdayopening2);
        fd.append("thursdayclosing2",this.thursdayclosing2);

        fd.append("fridayopening",this.fridayopening);
        fd.append("fridayclosing",this.fridayclosing);
        fd.append("fridayopening2",this.fridayopening2);
        fd.append("fridayclosing2",this.fridayclosing2);


        fd.append("saturdayopening",this.saturdayopening);
        fd.append("saturdayclosing",this.saturdayclosing);
        fd.append("saturdayopening2",this.saturdayopening2);
        fd.append("saturdayclosing2",this.saturdayclosing2);

        fd.append("sundayopening",this.sundayopening);
        fd.append("sundayclosing",this.sundayclosing);
        fd.append("sundayopening2",this.sundayopening2);
        fd.append("sundayclosing2",this.sundayclosing2);

        this.overlay=true;
        
        this.$http
          .post(this.$apidomain+"agent/createbusiness", fd)
          .then(res => {
            if(res.data.success)  
            {
              
              this.storeBusiness=res.data.business;
              this.$store.dispatch("assignBusiness",JSON.stringify(this.storeBusiness)).then(() => {
               
               });
              this.$router.push("/agent/businesslist");
              this.overlay=false;
            }  
            else
            {
                let errmsg=[];
                for(var prop in res.data.errors){
                    errmsg.push(res.data.errors[prop][0]);
                }
                this.overlay=false;
                alert(errmsg[0]);

            }
          })
          .catch(err => {
            console.log(err.response);
            this.overlay=false;
          });
      }
    }
  }
};
</script>
<style >
    .cropper {
	border: solid 1px #EEE;
	height: 300px;
	width: 100%;
}
</style>